import { render, staticRenderFns } from "./TypePicRequest.vue?vue&type=template&id=e0159cee&scoped=true"
import script from "./TypePicRequest.vue?vue&type=script&lang=js"
export * from "./TypePicRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0159cee",
  null
  
)

export default component.exports